<template>
  <div class="pa-2">
    <section class="nfe-hierarchy-card">
      <div class="pa-4">
        <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
          <div class="d-flex">
            <div class="mr-4">
              <span class="font-weight-bold"> Nfe: </span>
              <span class="font-weight-regular"> {{ nfe.number }} </span>
            </div>
            <div class="mr-4">
              <span class="font-weight-bold">Destinatário: </span>
              <TruncateDataWithTooltip
                :data="nfe.nameRecipient"
                :lengthDataToTruncate="truncateLimit"
              ></TruncateDataWithTooltip>
            </div>
            <div class="mr-4">
              <span class="font-weight-bold">Remetente: </span>
              <TruncateDataWithTooltip
                :data="nfe.nameSender"
                :lengthDataToTruncate="truncateLimit"
              ></TruncateDataWithTooltip>
            </div>
          </div>
        </v-card-text>
        <v-card-text class="d-flex pa-0" style="margin-left: 2px">
          <v-col class="pa-0" cols="12" md="12">
            <span class="font-weight-bold text--secondary">Preço: </span>
            <span class="font-weight-regular mr-4">{{ formatPrice(nfe.price) }}</span>
            <span class="font-weight-bold text--secondary">Peso: </span>
            <span class="font-weight-regular mr-4">{{ formatWeight(nfe.weight || nfe.Weight || 0) }}kg</span>
            <span class="font-weight-bold text--secondary">Número NFe: </span>
            <v-tooltip color="transparent" right nudge-left="25" nudge-bottom="30" max-width="330">
              <template v-slot:activator="{ on, attrs }">
                <span class="font-weight-regular">{{ nfe.number }}</span>
                <v-icon small @click="copy(nfe.accessKey)" v-bind="attrs" v-on="on">
                  mdi-checkbox-multiple-blank-outline
                </v-icon>
              </template>
              <span class="open-box">
                <v-card>
                  <v-card-text class="p-1" style="font-size: 10px; padding-top: 5px; padding-bottom: 5px">
                    Clique para copiar a chave de acesso:
                    {{ nfe.accessKey }}
                  </v-card-text>
                </v-card>
              </span>
            </v-tooltip>
          </v-col>
        </v-card-text>
      </div>
    </section>
  </div>
</template>

<script>
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import copyToClipboard from '@/utils/copyToClipboard';
import maskPrice from '@/utils/maskPrice';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';

export default {
  components: {
    TruncateDataWithTooltip
  },
  props: {
    nfe: {
      default: () => ({}),
      type: Object
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isCollapsed: false,
    hasRequested: false,
    alocatedNfes: []
  }),
  computed: {
    nfeHeaders() {
      const headers = [
        { value: 'number', text: 'NÚMERO NFE', sortable: true },
        { value: 'price', text: 'PREÇO', sortable: true },
        { value: 'weight', text: 'PESO', sortable: true }
      ];
      return headers;
    },
    localSelected: {
      get() {
        return this.selected;
      },
      set() {
        this.$emit('update:selected', this.nfe.id);
      }
    },
    confirmationText() {
      if (this.getErrorNfeCount) {
        return 'Você confirma excluir essa entrega?';
      } else {
        return 'Confirmar dasalocar as NFes e excluir essa entrega?';
      }
    },
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1360) return 8;
      if (width < 1440) return 10;
      if (width < 1520) return 16;
      if (width < 1680) return 20;
      if (width < 1820) return 26;
      return 34;
    }
  },
  watch: {
    nfe: {
      handler(value) {
        if (value) {
          this.getNfesByDelivery();
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('ImportManualDeliveryStore', ['getNfesByDeliveryId', 'allocateNfes']),
    async getNfesByDelivery(collapsed = false) {
      this.isLoadingAlocated = true;
      try {
        if (collapsed) {
          this.isCollapsed = !this.isCollapsed;
        }
        if (this.importedSuccessfully) {
          this.alocatedNfes = this.nfe.NfesTemp;
        } else {
          const data = await this.getNfesByDeliveryId(this.nfe.id || this.nfe.deliveryId);
          this.alocatedNfes = data;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoadingAlocated = false;
      }
    },
    isLongText(text) {
      return text && text.length > this.truncateLimit;
    },
    truncateText(text) {
      return text && text.length > this.truncateLimit ? text.substring(0, this.truncateLimit - 3) + '...' : text;
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    }
  }
};
</script>
<style scoped>
.nfe-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.nfe-hierarchy-card-collapsed {
  width: 220px;
  height: 54px;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
.checkbox-nfe {
  margin-top: 2px;
}
::v-deep .checkbox-nfe .v-input--selection-controls__input {
  margin-right: 0px;
}
</style>
